import { useMemo } from 'react';

import { useStudentDiplomasQuery } from 'core';
import { IMyDiploma, transformMyDiplomas } from './transform';

interface IUseMyDiplomas {
  diplomas: IMyDiploma[];
  loading: boolean;
  error: string;
}

/**
 * Reads the logged-in student's own issued diplomas via the `myDiplomas` query
 * (no arguments — the server derives the student from the JWT).
 *
 * `cache-and-network` so a diploma attached by staff after the tab was opened
 * surfaces on the next mount without a hard reload. An empty list is the normal
 * state for a student who has not graduated yet — it is not an error.
 */
export const useMyDiplomas = (): IUseMyDiplomas => {
  const { data, loading, error } = useStudentDiplomasQuery({
    fetchPolicy: 'cache-and-network',
  });

  const diplomas = useMemo(() => transformMyDiplomas(data), [data]);

  return {
    diplomas,
    loading,
    error: error?.message || '',
  };
};
